import { REDUCER } from '../reducers/reducersConst';

let defaultSelectedGroupState = {
  group: { id: 0, isEveryone: true }
};
export let selectedGroup = (state = defaultSelectedGroupState, action) => {
  switch (action.type) {
    case REDUCER.SEL_GROUP.SET_SELECTED_GROUP:
      return {
        ...state,
        group: action.group
      };
    default:
      return state;
  }
};

let defaultGroupState = {
  addGroupIsOpen: false,
  groupToRemove: null,
  editGroupIsOpen: false,
  groupToEdit: null,
  pictogramConfigGroup: null
};

export let group = (state = defaultGroupState, action) => {
  switch (action.type) {
    case REDUCER.GROUP.SET_ADD_GROUP_IS_OPEN:
      return {
        ...state,
        addGroupIsOpen: action.addGroupIsOpen
      };
    case REDUCER.GROUP.SET_GROUP_TO_REMOVE:
      return {
        ...state,
        groupToRemove: action.groupToRemove
      };
    case REDUCER.GROUP.SET_EDIT_GROUP_IS_OPEN:
      return {
        ...state,
        editGroupIsOpen: action.isOpen
      };
    case REDUCER.GROUP.SET_GROUP_TO_EDIT:
      return {
        ...state,
        groupToEdit: action.group
      };
    case REDUCER.GROUP.SET_PICTOGRAM_CONFIG:
      return {
        ...state,
        pictogramConfigGroup: action.pictogramConfigGroup
      };
    default:
      return state;
  }
};
